export default "__VITE_ASSET__CwdToI3a__"